import { StorageService } from '../../storage';

export const DEVICES_IN_MULTIPLE_CONTINENT = ['EUR', 'USD'];
export const EUROPE = 'europe';
export const AFRICA = 'africa';
export const ASIA = 'asia';
export const AMERICA = 'america';
export const EURO = 'EUR';
export const STORAGE_SERVICE = StorageService.getInstance();
export const USER_CURRENCY_COOKIE = 'userCurrency';
export const CONTRIB_ZONE_COOKIE = 'contribZone';
export const USER_BROWSING_ZONE_LOCALIZATION_COOKIE =
  'userBrowsingZoneLocalization';
export const BLACK_LIST = [
  'hotelsList',
  'compare-hotels',
  'room-dates',
  'rates',
  'options',
  'summary',
  'confirmation',
  'confirm',
  'review-cancel-booking',
  'payment',
  'additional-services',
  'advanced-searched-tourism',
  'alternativeDestination',
  'bedroom',
  'compare-hotels',
  'bedroom',
  'hotelsBerlin',
  'hotelsList',
  'hotelsLyon',
  'hotelsParis',
  'hotelsSaoPaulo',
  'hotelsSydney',
  'refineSearchDestination',
  'refineSearchList',
  'refineSearchMap'
];
export const ATTR_DATA_PAGE = 'data-currencyConvert';
export const ATTR_DATA_REBORN = 'data-rebornconvert';
export const EXPIRATION_MILLISECONDS = 21600000; // INFO: 6 hours
export const LOCAL_STORAGE_NAME = 'linkNavigation.currenciesViewBean';
export const REGEX_PREFIX_VIEWBEAN = /^({}&& )/;
export const URL_CHANGE_CURRENCY =
  '/currency/updateCurrencyCookie.action?changeUserCurrency=';
